import React, { Component } from 'react';
import { Form, withFormik } from 'formik';
import PropTypes from 'prop-types';
import { Checkbox } from 'semantic-ui-react';
import * as Yup from 'yup';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  injectStripe,
} from 'react-stripe-elements';
import { Input as FormInput } from '../Form';
import { withInputClassNames } from './../EditProfile/HOC';
import './PaymentForm.css';
import visa from './assets/visa.svg';
import master from './assets/master.svg';
import paypal from './assets/paypal.svg';
import { Button } from '../Button';
import ProjectSummary from './ProjectSummary/';
const Input = withInputClassNames(FormInput);

class PaymentForm extends Component {
  constructor(props) {
    super(props);
    this.state = { cardNumber: false };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCardChange = this.handleCardChange.bind(this);
  }

  handleSubmit(ev) {
    ev.preventDefault();
    const { stripe, onSubmit, values, setSubmitting } = this.props;
    setSubmitting(true);
    stripe
      .createToken(values)
      .then(({ token }) =>
        onSubmit({ ...values, token, projectResume: undefined }, setSubmitting),
      );
  }

  handleCardChange({ elementType, complete }) {
    this.setState({ [elementType]: complete });
  }

  render() {
    const { isSubmitting, dirty, projectResume, isValid } = this.props;

    const disableSubmit = !dirty || isSubmitting || !isValid;
    const { cardNumber, cardExpiry, cardCvc } = this.state;

    const completedCardInfo = cardNumber && cardExpiry && cardCvc;

    return (
      <div className="payment">
        <Form className="payment-card" onSubmit={this.handleSubmit}>
          <div className="payment-card__header">
            <h2>BILLING DETAILS</h2>
          </div>
          <div className="payment-card__content">
            <div className="payment-card__content-card">
              <div className="payment-card__content-card-content">
                <Input label="Full Name" name="account_holder_name" />
                <Input label="Company Name (optional)" name="company" />
                <Input label="Street Address" name="address_line1" />
                <Input label="Apartment, Floor, Etc." name="address_line2" />

                <div className="payment-card__content-card-content-half">
                  <div className="payment-card__content-card-content-half-first">
                    <Input label="State" name="address_state" />
                  </div>
                  <div className="payment-card__content-card-content-half-second">
                    <Input label="Zip Code" name="address_zip" />
                  </div>
                </div>

                <Checkbox label="Credit Card" name="credit_card" />
                <img src={visa} alt="visa" />
                <img src={master} alt="mastercard" />
                <Input label="Name On Card" name="name" />

                <div className="payment-card__content-card-content-cardelement">
                  <div className="edit-profile__content-input-label form-label">
                    Card Info
                  </div>
                  <div className="payment-card__content-card-content-cardinput">
                    <CardNumberElement
                      style={{ base: { fontSize: '18px' } }}
                      onChange={this.handleCardChange}
                    />
                  </div>
                </div>
                <div className="payment-card__content-card-content-cardelement">
                  <div className="payment-card__content-card-content-cardinput">
                    <div className="edit-profile__content-input-label form-label" />
                    <CardExpiryElement onChange={this.handleCardChange} />
                  </div>
                  <div className="payment-card__content-card-content-cardinput">
                    <div className="edit-profile__content-input-label form-label" />
                    <CardCVCElement onChange={this.handleCardChange} />
                  </div>
                </div>

                <Checkbox label="Paypal" name="paypal" />
                <img src={paypal} alt="paypal" />
              </div>
            </div>
            <ProjectSummary projectResume={projectResume} />
          </div>
          <div className="payment-card__actions">
            <Button
              className="payment-card__actions-button"
              rounded
              type="submit"
              title="PLACE ORDER"
              disabled={disableSubmit || !completedCardInfo}
            />
          </div>
        </Form>
      </div>
    );
  }
}

PaymentForm.propTypes = {
  isSubmitting: PropTypes.bool,
  dirty: PropTypes.bool,
  isValid: PropTypes.bool,
  projectResume: PropTypes.object,
  stripe: PropTypes.object,
  onSubmit: PropTypes.func,
  setSubmitting: PropTypes.func,
  values: PropTypes.object,
};

export default withFormik({
  validateOnBlur: true,
  validateOnChange: true,
  mapPropsToValues: ({ user }) => ({
    account_holder_name: user.name,
    company: user.company_name,
    address_state: user.state,
  }),
  validationSchema: Yup.object().shape({
    account_holder_name: Yup.string().required('Full Name is required'),
    address_line1: Yup.string().required('Address is required'),
    address_state: Yup.string().required('State is required'),
    address_zip: Yup.string().required('Zip is required'),
    name: Yup.string().required('Name On Card is required'),
  }),
  displayName: 'PaymentForm',
})(injectStripe(PaymentForm));



// WEBPACK FOOTER //
// ./src/components/PaymentForm/PaymentForm.js